module.exports = __webpack_public_path__ + "img/product-dummy.88f0e252.png";